import styled from "styled-components";

export const DividerContainer = styled.div`
  width: 100%;
  height: 1px;

  border-top: 1px solid var(--border);
`;
